"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlWidget = void 0;
const Widget_1 = require("../../core/render/Widget");
class HtmlWidget extends Widget_1.Widget {
    constructor(elementName, innerHTML) {
        super();
        if (elementName != null) {
            this.element = document.createElement(elementName);
            this.element.innerHTML = innerHTML;
        }
    }
    get element() {
        return this._element;
    }
    set element(value) {
        this._element = value;
        this.renderBody = value;
    }
    createElement(elementName, elementBuilder, appendChild = false) {
        let htmlWidget = new HtmlWidget(elementName, "");
        htmlWidget.parentWidget = this;
        if (this.renderBody == null) {
            this.renderBody = htmlWidget.renderBody;
        }
        if (appendChild || this.shouldAppendChild) {
            htmlWidget.shouldAppendChild = true;
            this.renderBody.appendChild(htmlWidget.renderBody);
        }
        this.widgets.push(htmlWidget);
        if (elementBuilder != null)
            elementBuilder(htmlWidget.element);
        return htmlWidget;
    }
    createElementAndAppend(elementName, elementBuilder, appendChild = false) {
        let htmlWidget = new HtmlWidget(elementName, "");
        htmlWidget.parentWidget = this;
        if (this.renderBody == null) {
            this.renderBody = htmlWidget.renderBody;
        }
        if (appendChild || this.shouldAppendChild) {
            htmlWidget.shouldAppendChild = true;
            this.renderBody.appendChild(htmlWidget.renderBody);
        }
        this.widgets.push(htmlWidget);
        if (elementBuilder != null)
            elementBuilder(htmlWidget.element);
        return this;
    }
    removeElement(element, removeChild = false) {
        if (removeChild) {
            this.renderBody.removeChild(element.renderBody);
        }
        this.widgets.splice(this.widgets.indexOf(element), 1);
    }
    createHeading(heading) {
        return this.createElement("h1", h1 => h1.textContent = heading);
    }
    createParagraph(paragraph) {
        return this.createElement("p", p => p.textContent = paragraph);
    }
    shouldRender() {
        return true;
    }
}
exports.HtmlWidget = HtmlWidget;
//# sourceMappingURL=HtmlWidget.js.map